import i18n from '@/i18n/i18n'
import { MobileContactService } from '@/services/retailer/MobileContactService'
import { errorMessage } from '@/utilities/helpers'

const { t } = i18n.global

export const namespaced = true

export const state = {
  mobile_contacts: null,
  mobile_contact: {},
  meta: null
}

export const mutations = {
  SET_MOBILE_CONTACTS(state, mobileContacts) {
    state.mobile_contacts = mobileContacts.data
    state.meta = mobileContacts.meta
  },
  SET_MOBILE_CONTACT(state, mobileContact) {
    state.mobile_contact = mobileContact
  }
}

export const getters = {
  mobileContact: state => id => {
    if (state.mobile_contacts) {
      return state.mobile_contacts.find(contact => contact.id === id)
    }

    return false
  }
}

export const actions = {
  getMobileContacts({ commit }, query) {
    return new Promise((resolve, reject) => {
      let mobileContactService = new MobileContactService(query)
      mobileContactService
        .getMobileContacts()
        .then(response => {
          commit('SET_MOBILE_CONTACTS', response)
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getMobileContact({ commit, getters }, id) {
    const contact = getters.mobileContact(id)

    if (contact) {
      commit('SET_MOBILE_CONTACT', contact)

      return contact
    }

    return new Promise((resolve, reject) => {
      let mobileContactService = new MobileContactService()
      mobileContactService
        .getMobileContact(id)
        .then(response => {
          commit('SET_MOBILE_CONTACT', response.data)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  updateMobileContact({ state, dispatch }, form) {
    return new Promise((resolve, reject) => {
      let mobileContactService = new MobileContactService()
      mobileContactService
        .updateMobileContact(form.id, form)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.retailer.mobile_contact.application_status_updated')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('shared.common.error') + ' :' + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
